import moment from 'moment'

export default class Utils {
  static groupBy (list, keyGetter) {
    const map = new Map()
    const array = []
    list.forEach((item) => {
      const key = keyGetter(item)
      const collection = map.get(key)
      if (!collection) {
        map.set(key, [item])
      } else {
        collection.push(item)
      }
    })
    map.forEach((value, key, map) => array.push({ key: key, values: value }))
    return array
  }

  static Quartile (array, index, total, sorted = false, i_key = 'total') {
    let arrayCopy = array.map(item => item)
    if (!sorted) {
      arrayCopy = arrayCopy.sort((a, b) => a[i_key] === b[i_key] ? 0 : a[i_key] > b[i_key] ? -1 : 1)
    }
    const underIndexItems = arrayCopy.filter(item => arrayCopy.indexOf(item) <= index).map(item => item[i_key])
    const accum = underIndexItems.length > 0 ? underIndexItems.reduce((a, b) => parseFloat(a) + parseFloat(b)) : 0
    const percentage = accum / total
    if (percentage < 0.25) {
      return 4
    }
    if (percentage < 0.50) {
      return 3
    }
    if (percentage < 0.75) {
      return 2
    }
    if (percentage <= 1) {
      return 1
    }
    return 4
  }

  static paymentDateCalc (groupPaymentDays, groupWeekDays, invoice) {
    const days = [
      { dayName: 'sunday', index: 0, letter: 'D' },
      { dayName: 'monday', index: 1, letter: 'L' },
      { dayName: 'tuesday', index: 2, letter: 'M' },
      { dayName: 'wednesday', index: 3, letter: 'Mi' },
      { dayName: 'thursday', index: 4, letter: 'J' },
      { dayName: 'friday', index: 5, letter: 'V' },
      { dayName: 'saturday', index: 6, letter: 'S' }
    ]
    let paymentDays = groupPaymentDays || 180
    const emittedOn = moment(invoice.emittedOn).format('L')
    let dueDate = moment(emittedOn).add(paymentDays, 'days').format('L')
    const paymentDay = new Date(dueDate).getDay()
    let entries = []
    if (groupWeekDays) {
      entries = Object.entries(groupWeekDays).filter(entry => entry[1]).map(entry => {
        const index = days.findIndex(day => day.dayName === entry[0])
        const diff = index - paymentDay < 0 ? index - paymentDay + 7 : index - paymentDay
        return Object.assign({}, { dayName: entry[0], index: index, diff: diff })
      })
      entries = entries.sort((a, b) => a.diff === b.diff ? 0 : a.diff > b.diff ? 1 : -1)
    }
    paymentDays = entries.length > 0 ? parseInt(paymentDays) + parseInt(entries[0].diff) : paymentDays
    dueDate = moment(emittedOn).add(paymentDays, 'days').format('L')
    return { date: dueDate, days: paymentDays }
  }

  static converBase64toBlob (content, contentType) {
    contentType = contentType || ''
    var sliceSize = 512
    var byteCharacters = window.atob(content) // method which converts base64 to binary
    var byteArrays = []

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize)
      var byteNumbers = new Array(slice.length)
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }
      var byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }

    var blob = new Blob(byteArrays, { type: contentType }) // statement which creates the blob
    return blob
  }

  static isObjectEmpty (obj) {
    if (obj === undefined || !obj) {
      return true
    }
    return (Object.entries(obj).length === 0 && obj.constructor === Object) ||
           (Object.entries(obj).length === 0 && obj.constructor === Array)
  }

  static setLocalToken () {
    if (!process.env.VUE_APP_ACCESS_TOKENS_LOCAL) { return '' }
    const allowedTokens = process.env.VUE_APP_ACCESS_TOKENS_LOCAL.split(',')
    if (allowedTokens) { return 'Bearer ' + allowedTokens[0] }
    return ''
  }

  // Token para la aplicacion base (dragones)
  static setBaseAppToken () {
    if (!process.env.VUE_APP_ACCESS_TOKENS_BASE_APP) { return '' }
    const allowedTokens = process.env.VUE_APP_ACCESS_TOKENS_BASE_APP.split(',')
    if (allowedTokens) { return 'Bearer ' + allowedTokens[0] }
    return ''
  }

  // Token para la aplicacion de dispersiones
  static setCreditDispersionsAppToken () {
    if (!process.env.VUE_APP_ACCESS_TOKENS_DISPERSIONS_APP) { return '' }
    const allowedTokens = process.env.VUE_APP_ACCESS_TOKENS_DISPERSIONS_APP.split(',')
    if (allowedTokens) { return 'Bearer ' + allowedTokens[0] }
    return ''
  }

  // Token para la aplicacion de creditsManagerV2
  static setCreditsManagerAppToken () {
    if (!process.env.VUE_APP_ACCESS_TOKENS_CM2_APP) { return '' }
    const allowedTokens = process.env.VUE_APP_ACCESS_TOKENS_CM2_APP.split(',')
    if (allowedTokens) { return 'Bearer ' + allowedTokens[0] }
    return ''
  }

  // Token para risk insights
  static setRiskyAppToken () {
    if (!process.env.VUE_APP_ACCESS_TOKENS_RISKY) { return '' }
    const allowedTokens = process.env.VUE_APP_ACCESS_TOKENS_RISKY.split(',')
    if (allowedTokens) { return 'Bearer ' + allowedTokens[0] }
    return ''
  }
}
